import { getBrowserAudios } from "../flow";

export function setVolume(volume: number) {
    getBrowserAudios().forEach((audio) => (audio.element.volume = linearToLogarithmicVolume(volume)));
}
export function linearToLogarithmicVolume(value: number): number {
    return (Math.exp(value) - 1) / (Math.E - 1);
}
